import { useEffect, useReducer } from "react";
import useAuthFetch from "../../hooks/useAuthFetch";
import VerificationProfileTable from "./VerificationProfileTable";

function reducer(state, action) {
  switch (action.type) {
    case "LOADING":
      return { ...state, isLoading: true };

    case "UPDATE":
      return { ...state, response: action.payload, isLoading: false };

    case "ERROR":
      return { ...state, response: null, isLoading: false };

    default:
      throw new Error();
  }
}

// The list endpoint returns `{ profiles, defaults }`; accept a bare array too.
const toProfiles = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.profiles)) return response.profiles;
  return null;
};

export default function AllVerificationProfiles() {
  const customFetch = useAuthFetch();
  const [state, dispatch] = useReducer(reducer, {
    response: null,
    isLoading: false,
  });

  const handleFetch = async () => {
    dispatch({ type: "LOADING" });
    try {
      const url = new URL(
        `${process.env.REACT_APP_API_URL}/v1/dashboard/verificationProfile/list`
      );
      const { response, status } = await customFetch(url, "GET");
      const profiles = toProfiles(response);
      if (status === 200 && profiles) {
        dispatch({ type: "UPDATE", payload: profiles });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "ERROR" });
    }
  };

  useEffect(() => {
    handleFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="overflow-y-hidden">
      <VerificationProfileTable reqState={state} refetch={handleFetch} />
    </div>
  );
}
